import * as React from "react";

const FormatTextPlain = ({ text, type }: any) => {
  let formattedText = "";
  if (type == "newLine") {
    formattedText = text.replace(/\n/g, "<br>");
  } else if (type == "tabulator") {
    formattedText = text.replace(/\t/g, '<span style="margin-left: 20px;"></span>');
  } else if (type == "digit") {
    formattedText = text.replace(/(\d+(\.\d*)+)/g, "<br><br>$1");
  } else if (type == "by2D") {
    formattedText = text.replace(/([^,]) {2,3}/g, "$1<br><br>");
  } else if (type == "dotSpace") {
    formattedText = text.replace(/\. /g, ".<br><br>");
  } else if (type == "onlyDot") {
    formattedText = text.replace(/\./g, ".<br><br>");
  }
  return <div dangerouslySetInnerHTML={{ __html: formattedText }} />;
};

export default FormatTextPlain;
